/* eslint-disable*/
import VueStoreService from './VueStoreService';

const RecordStatusService = {
  async getRecordStatus(filter, store) {
    const resp = await VueStoreService.get('record-status' + filter, store);
    return resp;
  },

  async updateRecordStatus(id, data, store) {
    const resp = await VueStoreService.patch('record-status/' + id, data, store);
    return resp;
  },

  async deleteRecordStatus(id, store) {
    const resp = await VueStoreService.delete('record-status/' + id, store);
    return resp;
  },

  async saveRecordStatus(data, store) {
    const resp = await VueStoreService.post('record-status', data, store);
    return resp;
  },
};

export default RecordStatusService;